function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 4.7,
  cy: 4.7,
  r: 4.4,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "inherit",
  strokeMiterlimit: 10
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7 11.7L7.8 7.8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "inherit",
  strokeMiterlimit: 10
});

function SvgSearchThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.9 11.9",
    strokeWidth: 0.5
  }, props), _ref, _ref2);
}

export default SvgSearchThin;